const analyzeTypes = {
  DISTRIBUTION: 'distribution',
  SCORE: 'score',
};

const analyzeSpecs = {
  PERCENT: 'percent',
  AVG: 'average',
  ENPS: 'enps',
};

const allAnonymizedLabel = '| All Anonymized |';

const heatmapSpecs = {
  PERCENT: 'percent',
  AVG: 'average',
  ENPS: 'enps',
};

const suggestion = {
  favorablePercentRelevant: 1000,
  bottomOrgWideRelevant: 10000,
  defaultEffectiveness: 3,
  maxSuggestionItemsPerSurvey: 12,
  maxSuggestionItemsPerCategory: 2,
};

const compareTypes = {
  orgWide: 'compare-orgWide',
  surveys: 'compare-surveys',
  attributes: 'compare-attributes',
  benchmarks: 'compare-benchmarks-',
  timeframes: 'compare-timeframes',
};

export { analyzeTypes, analyzeSpecs, heatmapSpecs, allAnonymizedLabel, suggestion, compareTypes };
